module.exports = __webpack_public_path__ + "img/100days-signup-header.cc6b3bcb.svg";